import firebase from '../../firebase/firebase';
import {
    notifyUser
} from '../../actions/notification-actions';
// TODO: Move all firebase RTDB references here so that if firebase realtime DB needs to be swapped out in the future it can all be done in one place.

const db = firebase.database();

export const addUserDataToClientAccount = ({
    firstName,
    lastName,
    phoneNum,
    provinceOfResidence,
    dateOfBirthTimestamp,
    userId,
    hasConsentedToMarketing,
    hasAgreedToTerms
}) => {
    let updates = {};
    console.log('Adding consumer data to userData (clients) node', userId);

    // clientdb.ref(`clients/${userId}`)
    updates[`/clients/${userId}/basicProfile/firstName`] = firstName;
    updates[`/clients/${userId}/basicProfile/lastName`] = lastName;
    updates[`/clients/${userId}/phone`] = phoneNum;
    updates[`/clients/${userId}/provinceOfResidence`] = provinceOfResidence;
    updates[`/clients/${userId}/dateOfBirthTimestamp`] = dateOfBirthTimestamp;
    updates[`/clients/${userId}/hasConsentedToMarketing`] = hasConsentedToMarketing;
    updates[`/clients/${userId}/hasAgreedToTerms`] = hasAgreedToTerms;
    // Can also add profile image to this basic profile. Email is kept separate on purpose. Do NOT add it here.
    updates[`/clients/${userId}/uid`] = userId;
    updates[`/clients/${userId}/verified`] = false;

    db.ref().update(updates, (error) => {
        if (error) {
            console.log('FIREBASE ERROR', error)
        }
    }).then(() => {
        console.log('New Consumer Client Data Saved');
    });
}

export const sendPaymentDetailsToServer = (clientId, serviceId, token, providerId, companyId, servicePeriod, percentTax, cb) => {
    // console.log('SENDING PAYMENT DETAILS TO SERVER @ DBUTILS');

    const paymentId = db.ref().push().key;
    const paymentRef = db.ref(`payments/${clientId}/${paymentId}`);
    const paymentData = {
        _id: paymentId,
        clientId,
        companyId,
        /* tslint:disable */
        paymentDate: firebase.database['ServerValue']['TIMESTAMP'],
        /* tslint:enable */
        percentTax,
        providerId,
        serviceId,
        servicePeriod,
        token,
    }
    paymentRef.set(paymentData)
        .then((res) => {
            // console.log('PAYMENT SENT. NOW LISTENING FOR PAYMENT CONFIRMATION')
            paymentRef.on('value', snap => {
                // console.log('PAYMENT CONFIRMED?', snap.val())
                if (snap.val().isComplete === true) {
                    // console.log('PAYMENT CONFIRMED.', snap.val())
                    cb(snap.val());
                }
            }, (error) => {
                console.log('FIREBASE ERROR', error)
            })
        })
        .catch(console.log);
}

// THIS IS NOT BEING USED
export const getEachServicePeriod = (periodId, userId) => {
    return new Promise(function (resolve, reject) {
        let activeServicePeriods = [];
        const gotActiveServicePeriod = snap => {
            if ((userId && snap.val().providerId === userId) || (userId && snap.val().clientId === userId)) {
                // This user owns this service period or is the provider of this service
                // For each activeServicePeriod that this user has access to add it resolves
                resolve(snap.val());
            }
        }
        db.ref(`clients/${userId}`).once('value', snap => {
            if (snap.val().provider === true) {
                db.ref(`activeServicePeriods/${periodId}`).orderByChild('providerId').equalTo(userId).once('child_added', gotActiveServicePeriod, e => console.log);
            } else {
                db.ref(`activeServicePeriods/${periodId}`).orderByChild('clientId').equalTo(userId).once('child_added', gotActiveServicePeriod, e => console.log);
            }
        })
    });
}

export const getServicePeriod = (periodId) => {
    return new Promise((resolve, reject) => {
        const gotActiveServicePeriod = snap => {
            resolve(snap.val());
        }
        db.ref(`activeServicePeriods/${periodId}`)
            .once('value', gotActiveServicePeriod, e => console.log)
            .catch(console.log);
    });
};

export const makeUniqueId = (sufix, randomLength = 5, haveDash = true) => {
    let text = "";
    const possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

    for (let i = 0; i < randomLength; i++) {
        text += possible.charAt(Math.floor(Math.random() * possible.length));
    }
    // console.log('random-id', text + '-' + sufix)
    return text + (haveDash ? '-' : '') + sufix;
};
export const cynoEncryptionKey = 'app_cyno_encryption_key';

export const logFirebaseError = (error, custom_message = '') => {
    if (error) {
        console.log('FIREBASE ERROR:', error, custom_message)
    }
}


// WEBPACK FOOTER //
// ./src/js/utils/database/database-utils.js